import {
  Directive,
  ElementRef,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';

@Directive({
  selector: '[pluginsVerticalOffset]',
  standalone: true,
})
export class VerticalOffsetDirective implements OnInit, OnDestroy {
  @Input('pluginsVerticalOffset') offset = 0;
  @Input('pluginsVerticalOffsetDisabled') disabled = false;

  @HostBinding('style.margin-top.px') marginTop = 0;
  @HostBinding('style.opacity') opacity = 0;

  #elemRef = inject(ElementRef) as ElementRef<HTMLElement>;

  #observer = new IntersectionObserver(this.#position.bind(this), {
    threshold: 1,
  });
  #intersected = false;

  ngOnInit(): void {
    if (this.disabled) {
      this.opacity = 1;
      return;
    }
    this.marginTop = this.offset;
    this.#observer.observe(this.#elemRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.#observer.disconnect();
  }

  #position(entries: IntersectionObserverEntry[]) {
    entries.forEach((entry) => {
      if (!entry.intersectionRatio) {
        this.#intersected = false;
        this.#offset();
      } else {
        this.#intersected = true;
        this.#observer.disconnect();
        this.marginTop =
          this.marginTop +
          (entry.boundingClientRect.height -
            entry.intersectionRatio * entry.boundingClientRect.height) +
          this.offset;
        this.opacity = 1;
      }
    });
  }

  #offset() {
    if (!this.#intersected) {
      this.marginTop += 25;
      setTimeout(() => {
        this.#offset();
      });
    }
  }
}
